import { request } from '../../Common/api/client';

function normalizeApiError(error) {
  const body = error?.response?.data;
  if (body && typeof body === 'object' && body.code !== undefined) {
    const normalized = new Error(body.msg || error.message || '요청 처리에 실패했습니다.');
    normalized.code = Number(body.code);
    normalized.data = body.data;
    normalized.response = error.response;
    return normalized;
  }
  return error;
}

async function gnpRequest(config) {
  try {
    return await request(config);
  } catch (error) {
    throw normalizeApiError(error);
  }
}

export function createGnpShinsungSyncPreview() {
  return gnpRequest({
    method: 'POST',
    url: '/api/admin/gnp/shinsung-sync/preview',
  });
}

export function getGnpShinsungSyncBatches(params = {}) {
  return gnpRequest({
    method: 'GET',
    url: '/api/admin/gnp/shinsung-sync/batches',
    params,
  });
}

export function getGnpShinsungSyncBatch(batchId, params = {}) {
  return gnpRequest({
    method: 'GET',
    url: `/api/admin/gnp/shinsung-sync/batches/${encodeURIComponent(batchId)}`,
    params,
  });
}

export function applyGnpShinsungSyncBatch(batchId) {
  return gnpRequest({
    method: 'POST',
    url: `/api/admin/gnp/shinsung-sync/batches/${encodeURIComponent(batchId)}/apply`,
    data: { confirm: 'APPLY' },
  });
}

export function cancelGnpShinsungSyncBatch(batchId) {
  return gnpRequest({
    method: 'POST',
    url: `/api/admin/gnp/shinsung-sync/batches/${encodeURIComponent(batchId)}/cancel`,
    data: { confirm: 'CANCEL' },
  });
}
